import { Route } from '@angular/router';
import { initialDataResolver } from 'app/app.resolvers';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { LayoutComponent } from 'app/layout/layout.component';
import { ReaderGuard } from './core/auth/guards/clearance.guard';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [

    // Redirect empty path to '/companies'
    {path: '', pathMatch : 'full', redirectTo: 'map'},

    // Redirect signed-in user to the '/companies'
    //
    // After the user signs in, the sign-in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    {path: 'signed-in-redirect', pathMatch : 'full', redirectTo: 'map'},

    // Auth routes for guests
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'confirmation-required', loadChildren: () => import('app/modules/auth/confirmation-required/confirmation-required.routes')},
            {path: 'forgot-password', loadChildren: () => import('app/modules/auth/forgot-password/forgot-password.routes')},
            {path: 'reset-password', loadChildren: () => import('app/modules/auth/reset-password/reset-password.routes')},
            {path: 'sign-in', loadChildren: () => import('app/modules/auth/sign-in/sign-in.routes')},
            {path: 'sign-up', loadChildren: () => import('app/modules/auth/sign-up/sign-up.routes')}
        ]
    },

    // Auth routes for authenticated users
    {
        path: '',
        canActivate: [ReaderGuard],
        canActivateChild: [ReaderGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'sign-out', loadChildren: () => import('app/modules/auth/sign-out/sign-out.routes')},
            {path: 'unlock-session', loadChildren: () => import('app/modules/auth/unlock-session/unlock-session.routes')}
        ]
    },

    // Landing routes
    {
        path: '',
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'home', loadChildren: () => import('app/modules/template/landing/home/home.routes')},
        ]
    },

    // Admin routes
    {
        path: '',
        canActivate: [ReaderGuard],
        canActivateChild: [ReaderGuard],
        component: LayoutComponent,
        // TODO magari serve
        // data       : {
        //     layout: 'classy'
        // },
        resolve: {
            initialData: initialDataResolver
        },
        children: [
            // PATH DI ESEMPIO: TODO rimuovere e sostituire con quello che vuoi tu
            {
                path: 'map', loadChildren: () => import('app/modules/map/map.routes')
            },
            {
                path: 'companies', loadChildren: () => import('app/modules/companies/companies.routes')
            },
            {
                path: 'locations', loadChildren: () => import('app/modules/locations/locations.routes')
            },
            {
                path: 'motorized-pulleys', loadChildren: () => import('app/modules/motorized-pulleys/motorized-pulleys.routes')
            },
            {
                path: 'example', loadChildren: () => import('app/modules/template/admin/example/example.routes')
            },
            {
                path: 'settings', loadChildren: () => import('app/modules/template/admin/impostazioni/impostazioni.routes')
            },
            {
                path: 'crud',
                children: [
                    {
                        path: 'meta-dati', loadChildren: () => import('app/modules/template/admin/crud/meta-dati/meta-dati.routes')
                    }
                ]
            }
        ]
    }
];
